import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { Tooltip, InfoIcon } from '@spotahome/ui-library';

import CheckBox from '@spotahome/marketplace-common/src/LEGACY/javascripts/ui/form/form-checkbox';

import ADVANCED from '../../Filters/advanced-config';

import './FiltersExposedSection.scss';

import FiltersExposedWrapper from './FiltersExposedSectionWrapper';

const isFilterSelected = (filter, name) => parseInt(filter[name], 10) === 1;

const CheckboxSectionFilter = ({ onFiltersUpdate, filters, titleKey }) => {
  const handleToggleFilterCheckbox = (filter, name) => {
    const value = filter[name];
    onFiltersUpdate({
      [name]: value === 1 ? 0 : 1
    });
  };

  return (
    <FiltersExposedWrapper title={trans(titleKey)}>
      {ADVANCED.map(({ name, labelKey, tracking, cy, tooltipTextKey }) => (
        <div className="filters-exposed-section__filter" key={name}>
          <CheckBox
            id={name}
            label={trans(labelKey)}
            onChange={() => handleToggleFilterCheckbox(filters, name)}
            checked={isFilterSelected(filters, name)}
            tracking={tracking}
            cy={cy}
          />
          {tooltipTextKey && (
            <Tooltip
              className="filters-exposed-section__tooltip"
              color="blue-cerulean"
              tooltip={trans(tooltipTextKey)}
              placement="top"
              trigger={['click', 'hover']}
            >
              <InfoIcon size={16} />
            </Tooltip>
          )}
        </div>
      ))}
    </FiltersExposedWrapper>
  );
};

CheckboxSectionFilter.propTypes = {
  onFiltersUpdate: PropTypes.func.isRequired,
  filters: PropTypes.shape({}).isRequired,
  titleKey: PropTypes.string.isRequired
};

export default CheckboxSectionFilter;
